/**
 * Storyblok's Image Service allows us optimize an image served from their CDN
 * Appending '/m/' converts the image to webp
 * https://www.storyblok.com/docs/image-service
 */

export const optimizeStoryblokImage = (src: string) => {
    return `${src}/m/`
}
